import { render } from "./CIS-StructuredData-Website.vue?vue&type=template&id=27f1ff7b"
import script from "./CIS-StructuredData-Website.vue?vue&type=script&lang=js"
export * from "./CIS-StructuredData-Website.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__